"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagGroup = void 0;

var tslib_1 = require("tslib");

var ui_box_1 = require("@hopin-team/ui-box");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_pill_1 = require("@hopin-team/ui-pill");

var ui_text_1 = require("@hopin-team/ui-text");

var use_id_1 = require("@hopin-team/use-id");

var react_1 = tslib_1.__importDefault(require("react"));

var TagGroup = function TagGroup(_a) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      label = _a.label,
      id = _a.id,
      tags = _a.tags,
      ariaLabel = _a["aria-label"],
      _b = _a.isRemovable,
      isRemovable = _b === void 0 ? true : _b,
      removeLabel = _a.removeLabel,
      onRemove = _a.onRemove,
      isCapped = _a.isCapped;

  var _c = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'TagGroup',
    className: className,
    __UIScope: __UIScope
  }),
      rootClasses = _c.rootClasses,
      makeClasses = _c.makeClasses;

  var labelId = (0, use_id_1.useId)(id);
  var a11yProps = {};

  if (label) {
    a11yProps['aria-labelledby'] = labelId;
  } else {
    a11yProps['aria-label'] = ariaLabel;
  }

  return react_1.default.createElement("div", {
    className: rootClasses,
    "data-testid": testID
  }, label && react_1.default.createElement(ui_text_1.Text, {
    className: makeClasses('Label'),
    pattern: "captionMedium",
    element: "label",
    id: labelId,
    mb: 0.5
  }, label), react_1.default.createElement(ui_box_1.Box, tslib_1.__assign({}, a11yProps), tags.map(function (tag, i) {
    return react_1.default.createElement(ui_pill_1.Pill, {
      key: i,
      id: tag,
      label: tag,
      isRemovable: isRemovable,
      removeLabel: removeLabel,
      onRemove: onRemove,
      isCapped: isCapped,
      mr: 1,
      mb: 1
    });
  })));
};

var TagGroupWithSpace = (0, ui_helper_with_space_1.withSpace)(TagGroup);
exports.TagGroup = TagGroupWithSpace;